<!-- 历史问题 -->
<template>
  <div class='container'>
    <el-dialog
      v-loading="loading"
			title="历史问题查看"
			:visible.sync="isShow"
			:close-on-click-modal="false"
			width='800px' class='default-dialog'>
      <div class="period-box">
        期间：<AccountingPeriod @defaultTime='defaultTime' :isEmpty="true" />
      </div>
			<CommonTable 
        :data="tableData" 
        :field-list="tableHeader"
        :checkBox="false"
        :pager="false"
        ref="PublicTable" />
			<div slot="footer" align="center" class="dialog-footer" v-if="!loading">
        <el-button size="small" class='minButton' @click="handleConfirm" :disabled="isDisabled">关闭</el-button>
      </div>

		</el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable"
import AccountingPeriod from '@/components/dialog/accountingPeriod'
import { findRejects } from '@/api'
export default {
  components:{ CommonTable,AccountingPeriod },
  props:{},
  created() {},
  data() {
    return {
      isShow: false,
      isDisabled: false,
      loading: false,
      tableData: [],
      startYearPeriods: '',
      endYearPeriods: '',
      tableHeader: [
        { label: '账期', props: 'yearPeriods', header: false, overflow: true, minWidth: '110px' },
        { label: '驳回原因', props: 'problem', header: false, overflow: true, minWidth: '110px'},
        { label: '管理会计', props: 'name', header: false, overflow: true, minWidth: '110px'},
        { label: '时间', props: 'examineDate', header: false, overflow: true, minWidth: '110px', type: "date",dateType: 'yyyy-MM-dd' },
      ],
    }
  },
  methods:{
    handleOpen() {
      this.isShow = true
      this.startYearPeriods = '',
      this.endYearPeriods = ''
      this.getRejectList()
    },
    handleConfirm() {
      this.isShow = false
    },
    // 获取列表数据
    async getRejectList() {
      try {
        this.loading = true
        const { data } = await findRejects({
          cid: JSON.parse(sessionStorage.getItem("cid")),
          isHistory: true,
          startYearPeriods: this.startYearPeriods,
          endYearPeriods: this.endYearPeriods,
        })
        if(data.code == 1) {
          this.tableData = data.data
          this.loading = false
        }
      } catch (error) {
        this.loading = false
      }
    },
    // 接收会计期间数据
    defaultTime(data) {
      this.startYearPeriods = this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
      this.endYearPeriods = this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM')
      this.getRejectList()
    },
  },
}
</script>

<style lang='less' scoped>
.period-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/HistoryExistProblems.vue